import { render, staticRenderFns } from "./scoreBord.vue?vue&type=template&id=87cff046&"
import script from "./scoreBord.vue?vue&type=script&lang=js&"
export * from "./scoreBord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports